export default __webpack_public_path__ + "static/media/iPod_Exploded-0.25ETHM.d23692cf.mp4";